export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "load_failed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impossible de charger la connexion Google. Rechargez la page."])}
      },
      "en": {
        "load_failed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unable to load Google sign-in. Please reload the page."])}
      }
    }
  })
}
